import React from 'react';
import PropTypes from 'prop-types';

import './graph.scss';
import GenericCategoryGraph, { chartTypeEnum } from './GenericCategoryGraph';
import { manipulateColor } from './CompositeGraph/ColorTools';

export const GetTimeCodesDataSeries = colorPalette => [
  {
    name: 'Enrollments with 20/40/60 min Code',
    color: colorPalette?.interpolate(0.73),
    selector: item => item['enrollmentsWithCode'],
  },
  {
    name: "Enrollments without 20/40/60 min Code",
    color: colorPalette?.interpolate(0.25),
    selector: item => item['enrollmentsWithoutCode'],
  },
];
export default function TimeCodesGraph(props) {
  const { graphData, graphType } = props;
  return (
    <GenericCategoryGraph
      graphData={graphData}
      hasBorder={true}
      forceCondensed
      xAxisTopPosition={false}
      //xAxisLabelsMinMaxOnly
      yAxisWidth={graphType === chartTypeEnum.horizontalStackedBar ? 60 : 40}
      yAxisUnit=""
      tooltipTitle={'Patients per Program'}
      dataSeries={GetTimeCodesDataSeries(props.colorPalette)}
      categorySelector={item => item.code}
      hasReferenceAreas={true}
      graphType={graphType}
    />
  );
}

TimeCodesGraph.propTypes = { graphData: PropTypes.array };
